module.exports = __webpack_public_path__ + "img/Insulation-Training-01.edfc83b8.png";